import React, { useEffect } from "react";
import "./CoreTeam.css";

import teamImg from "../../assets/images/team.jpg";

const CoreTeam = () => {
  useEffect(() => {
    const elements = document.querySelectorAll(".zoom-scroll");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          } else {
            entry.target.classList.remove("show");
          }
        });
      },
      { threshold: 0.2 }
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="core-team-section">
      
      {/* Heading above image */}
      <div className="team-heading zoom-scroll">
        <h2>Our Core Team</h2>
        <div className="scroll-line"></div>
      </div>

      {/* Image below heading */}
      <div className="team-image zoom-scroll">
        <img src={teamImg} alt="Core Team" />
      </div>

    </section>
  );
};

export default CoreTeam;
